import React from "react";
import { View, StyleSheet } from "react-native";
import Text from "@components/CustomText";
import { useSelector } from "react-redux";
import EmojiView from "./EmojiView";
import giveRating from "../utils/giveRating";
import ReasonModal from "./ReasonModal";

const BAD_RATING_IF_LESS_THAN = 4;

const RatingView = ({
  ticket_id,
  issueLevel1,
  handleReloadList = () => {},
  showReopenModalHandler = () => {},
  marginBtw = "",
}) => {
  const clTicketDisSatisfactionReasons = useSelector(
    (state) => state.support.clTicketDisSatisfactionReasons,
  );

  const [showReasons, setShowReason] = React.useState(false);
  const [selectedRating, setSelectedRating] = React.useState(null);

  const onEmojiClick = (rating, callback) => {
    if (rating < BAD_RATING_IF_LESS_THAN) {
      setShowReason(true);
      setSelectedRating(rating);
      return;
    }
    callback();
    setTimeout(() => {
      giveRating(rating, ticket_id, issueLevel1)(handleReloadList);
    }, 1500);
  };

  const onSubmitReason = (reasons = [], cancelled = false) => {
    if (cancelled) {
      giveRating(selectedRating, ticket_id, issueLevel1)(handleReloadList);
      return;
    }
    giveRating(selectedRating, ticket_id, issueLevel1, reasons)();
  };

  return (
    <View style={styles.container}>
      <ReasonModal
        showReasonsModal={showReasons}
        onCloseClick={setShowReason}
        clTicketDisSatisfactionReasons={clTicketDisSatisfactionReasons}
        selectedRating={selectedRating}
        onSubmit={onSubmitReason}
        handleReloadList={handleReloadList}
      />
      <Text variant="subtitle_16">हमें रेट करें </Text>
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          marginLeft: marginBtw ? marginBtw : 0,
        }}
      >
        <EmojiView
          showReopenModalHandler={showReopenModalHandler}
          handleReload={handleReloadList}
          ticket_id={ticket_id}
          issueLevel1={issueLevel1}
          type="terrible"
          onEmojiClick={onEmojiClick}
        />
        <EmojiView
          showReopenModalHandler={showReopenModalHandler}
          handleReload={handleReloadList}
          ticket_id={ticket_id}
          issueLevel1={issueLevel1}
          type="bad"
          onEmojiClick={onEmojiClick}
        />
        <EmojiView
          showReopenModalHandler={showReopenModalHandler}
          handleReload={handleReloadList}
          ticket_id={ticket_id}
          issueLevel1={issueLevel1}
          type="okay"
          onEmojiClick={onEmojiClick}
        />
        <EmojiView
          showReopenModalHandler={showReopenModalHandler}
          handleReload={handleReloadList}
          ticket_id={ticket_id}
          issueLevel1={issueLevel1}
          type="good"
          onEmojiClick={onEmojiClick}
        />
        <EmojiView
          showReopenModalHandler={showReopenModalHandler}
          handleReload={handleReloadList}
          ticket_id={ticket_id}
          issueLevel1={issueLevel1}
          type="great"
          onEmojiClick={onEmojiClick}
        />
      </View>
    </View>
  );
};

export default RatingView;

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: "#FFFFFF",
    paddingHorizontal: 24,
    paddingBottom: 15,
    paddingTop: 8,
  },
});
